// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legend-root {
    position: relative;
}

.legend-container {
    overflow: hidden;
}

.menu-root {
    position: absolute;
    top: -2px;
    left: -29px;
}

.title-visibility {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 20px;
    margin-left: -15px;
    height: 20px;
    margin-top: -2px;
}

.icon-arrow {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.flex-wrap {
    display: flex;
    justify-content: space-between;
}

.line {
    flex-grow: 1;
    margin-right: 20px;
}

.visible-wrap {
    position: absolute;
    top: 0px;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #F5F0F5;
}

.visible {
    background-color: #D0D0D0;
}

    .visible svg {
        fill: #000;
    }

.tabulator-col {
    background-color: #F5F0F5;
}

    .tabulator-col svg {
        fill: #9D9C9D;
    }

.menu-checkbox {
    padding: 5px;
    background-color: #F5F0F5;
}

.visible-wrap svg {
    fill: #9D9C9D;
}


.visible-block {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.header-visible-container{
    height: 16px;
}
.header-visible {
    position: absolute;
    margin-top: 2px;
    left: 50%;
    margin-left: -11px;
}

.cell-group-wrap {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.cell-group-wrap span {
    color: rgba(30, 144, 255, 1);
    position: absolute;
    top: 1px;
    right: 5px;

}
.cell-scale-text{
    text-align: center;
    width: 100%;
}
.disable-text{
    opacity: 50%;
}
.scale-no-use{
    width: 100%;
    height: 27px;
    text-align: center;
    color: #fff;
    position: absolute;
    background: #1E90FF;
}
.tooltip-wrap {
    position: relative;
}

.tooltip-wrap:hover .tooltip {
    opacity: 1;
    pointer-events: all;
    transition-delay: 0.5s;
}

.tooltip-wrap .tooltip {
    transition: .3s;
    position: absolute;
    width: max-content;
    bottom: calc(100% + 10px);
    left: 0;
    opacity: 0;
    pointer-events: none;
}

`, "",{"version":3,"sources":["webpack://./src/controls/legend/legend.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gDAAkC;AACtC;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;IAEI;QACI,UAAU;IACd;;AAEJ;IACI,yBAAyB;AAC7B;;IAEI;QACI,aAAa;IACjB;;AAEJ;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,QAAQ;IACR,UAAU;;AAEd;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,OAAO;IACP,UAAU;IACV,oBAAoB;AACxB","sourcesContent":[".legend-root {\r\n    position: relative;\r\n}\r\n\r\n.legend-container {\r\n    overflow: hidden;\r\n}\r\n\r\n.menu-root {\r\n    position: absolute;\r\n    top: -2px;\r\n    left: -29px;\r\n}\r\n\r\n.title-visibility {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    width: 20px;\r\n    margin-left: -15px;\r\n    height: 20px;\r\n    margin-top: -2px;\r\n}\r\n\r\n.icon-arrow {\r\n    content: url('./assets/arrow.svg');\r\n}\r\n\r\n.flex-wrap {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.line {\r\n    flex-grow: 1;\r\n    margin-right: 20px;\r\n}\r\n\r\n.visible-wrap {\r\n    position: absolute;\r\n    top: 0px;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: #F5F0F5;\r\n}\r\n\r\n.visible {\r\n    background-color: #D0D0D0;\r\n}\r\n\r\n    .visible svg {\r\n        fill: #000;\r\n    }\r\n\r\n.tabulator-col {\r\n    background-color: #F5F0F5;\r\n}\r\n\r\n    .tabulator-col svg {\r\n        fill: #9D9C9D;\r\n    }\r\n\r\n.menu-checkbox {\r\n    padding: 5px;\r\n    background-color: #F5F0F5;\r\n}\r\n\r\n.visible-wrap svg {\r\n    fill: #9D9C9D;\r\n}\r\n\r\n\r\n.visible-block {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.header-visible-container{\r\n    height: 16px;\r\n}\r\n.header-visible {\r\n    position: absolute;\r\n    margin-top: 2px;\r\n    left: 50%;\r\n    margin-left: -11px;\r\n}\r\n\r\n.cell-group-wrap {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.cell-group-wrap span {\r\n    color: rgba(30, 144, 255, 1);\r\n    position: absolute;\r\n    top: 1px;\r\n    right: 5px;\r\n\r\n}\r\n.cell-scale-text{\r\n    text-align: center;\r\n    width: 100%;\r\n}\r\n.disable-text{\r\n    opacity: 50%;\r\n}\r\n.scale-no-use{\r\n    width: 100%;\r\n    height: 27px;\r\n    text-align: center;\r\n    color: #fff;\r\n    position: absolute;\r\n    background: #1E90FF;\r\n}\r\n.tooltip-wrap {\r\n    position: relative;\r\n}\r\n\r\n.tooltip-wrap:hover .tooltip {\r\n    opacity: 1;\r\n    pointer-events: all;\r\n    transition-delay: 0.5s;\r\n}\r\n\r\n.tooltip-wrap .tooltip {\r\n    transition: .3s;\r\n    position: absolute;\r\n    width: max-content;\r\n    bottom: calc(100% + 10px);\r\n    left: 0;\r\n    opacity: 0;\r\n    pointer-events: none;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
